<template>
  <vs-popup class="update-rm-order-pop-up"
            title="UPDATE RM ORDER"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow id="rm-order-details-update-popup">
      <ValidationObserver v-if="update_type === 'details'" ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateProductOrder)" autocomplete="off">

          <vx-card title="Delivery Address" cardBorder class="mb-4">
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <customer-dropdown v-on:onInput="onSelectCustomerDropdown" :field_label="'Customer'" /> 
              </div>
            </div>
            <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="delivery_address" name="delivery_address" rules="" v-slot="{ errors }">
                        <small class="label">Select a delivery address</small>
                        <v-select
                          v-on:input="onChangeSelectDeliveryAddress"
                          name="delivery_address" placeholder=""
                          :reduce="option => option"
                          label="country"
                          :options="customer_addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
              </div>
              <hr class="my-4">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input readonly v-model="createForm.delivery_address.name"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input readonly v-model="createForm.delivery_address.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input readonly v-model="createForm.delivery_address.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input readonly v-model="createForm.delivery_address.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input readonly v-model="createForm.delivery_address.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input readonly v-model="createForm.delivery_address.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select disabled :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.delivery_address.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.delivery_address.note" height="120px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          </vx-card>
          
          <vx-card title="Invoice Address" cardBorder class="mb-4">
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input readonly v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input readonly v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input readonly v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input readonly v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input readonly v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select disabled :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          </vx-card>

          <div class="vx-row mb-3">
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="sage_nominal_code_id" name="sage_nominal_code_id" rules="required" v-slot="{errors}">
                      <small class="label">Sage Nominal Code</small>
                      <v-select :clearable="false" name="sage_nominal_code_id" placeholder=""
                                label="name" v-model="createForm.sage_nominal_code_id" :reduce="option => option.id"
                                :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
             <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                <small class="label">Sage Department</small>
                <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                          label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                          :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              </ValidationProvider>
             </div>
             <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                <small class="label">Region</small>
                <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                          label="name" v-model="createForm.region_id" :reduce="option => option.id"
                          :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              </ValidationProvider>
             </div>
             <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                        <small class="label">Required By Date</small>
                        <flat-pickr class="w-full"
                                    style="display: none"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="createForm.required_by"
                                    placeholder="Choose Date"
                        />
                      <flat-pickr class="w-full"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="createForm.required_by"
                                  placeholder="Choose Date"
                      />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
              </div>
           </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                <small class="label">Delivery Instructions</small>
                <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="120px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="120px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vx-card subtitle="Additional Cost" cardBorder>
            <div class="vx-row mb-3" v-for="(cost, cost_index) in createForm.additional_costs" :key="cost_index">
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider :vid="cost_index+'name'" :name="cost_index+'name'" rules="required" v-slot="{ errors }">
                  <small class="label">Details</small>
                  <vs-input v-model="cost.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider :vid="cost_index+'amount'" :name="cost_index+'amount'" rules="required" v-slot="{ errors }">
                  <small class="label">Value</small>
                  <vs-input v-model="cost.amount"  name="amount" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/5 w-full md:mb-0">
                <small class="label">&nbsp;</small>
                <vs-button @click.stop="onClickRemoveCost(cost_index)" size="small" color="danger" class="mt-2 ml-4">Remove</vs-button>
              </div>
            </div>
            <div class="vx-row">
              <vs-button @click.stop="onClickAddNewCost" size="small" class="mt-4 ml-4">+ Add</vs-button>
            </div>
          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>

      <div v-if="update_type === 'items'" class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-table id="rm-order-item-table" :hoverFlat="true" :data="createForm.raw_material_items">

            <template slot="thead">
              <vs-th width="10%" class="text-xs">ITS PRODUCT CODE</vs-th>
              <vs-th width="15%" class="text-xs">ITS PRODUCT NAME</vs-th>
              <vs-th width="10%" class="text-xs">QC STATUS</vs-th>
              <vs-th width="15%" class="text-xs">ITEM STATUS</vs-th>
              <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>
              <vs-th width="10%" class="text-xs">PRICE (GBP)</vs-th>
              <vs-th v-if="createForm.raw_material_items[0] && !__isCurrencyGbp(createForm.raw_material_items[0].currency)" width="10%" class="text-xs">PRICE ({{ createForm.raw_material_items[0].currency }})</vs-th>
              <vs-th width="10%"  class="justify-end ml-auto mr-0 text-xs">TOTAL PRICE (GBP)</vs-th>
              <vs-th v-if="createForm.raw_material_items[0] && !__isCurrencyGbp(createForm.raw_material_items[0].currency)" width="10%" class="justify-end ml-auto mr-0 text-xs">TOTAL PRICE ({{ createForm.raw_material_items[0].currency }})</vs-th>
              <vs-th width="10%" class="text-xs">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="text-sm" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="font-semibold" :data="data[indextr].company_product_code">
                  {{data[indextr].category.prefix}}-{{ data[indextr].company_product_code }}
                </vs-td>

                <vs-td :data="data[indextr].company_product_name">
                  {{ data[indextr].company_product_name }}
                </vs-td>

                <vs-td :data="data[indextr].q_c_status">
                  {{ data[indextr].q_c_status || 'N/A'}}
                </vs-td>

                <vs-td>
                  {{ data[indextr].item_status || ''}}
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  <vs-input  type="text" v-model="data[indextr].quantity" class="w-full"
                             :name="indextr+'quantity'" />
                </vs-td>

                <vs-td :data="data[indextr].gbp_price">
                  <vs-input  type="text" v-model="data[indextr].gbp_price" class="w-full"
                             :name="indextr+'gbp_price'"
                             @input="onGbpPriceChange(data[indextr])" />
                </vs-td>

                <vs-td v-if="!__isCurrencyGbp(data[indextr].currency)" :data="data[indextr].price">
                  <vs-input  type="text" v-model="data[indextr].price" class="w-full"
                             :name="indextr+'price'"
                             @input="onSupplierPriceChange(data[indextr])" />
                </vs-td>

                 <vs-td>
                  {{data[indextr].quantity ? (Number(data[indextr].gbp_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>

                <vs-td v-if="!__isCurrencyGbp(data[indextr].currency)">
                  {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>

                <vs-td>
                  <vx-tooltip class="mr-2" text="Update quantity and price" position="top">
                    <vs-button :id="'update_button'+''+ indextr"
                               @click.stop="onClickUpdateCart(data[indextr].id, data[indextr].quantity, data[indextr].gbp_price, indextr)"
                               size="small" color="primary" type="border" icon-pack="feather" icon="icon-save"></vs-button>
                  </vx-tooltip>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'

  function initialState() {
    return {
      open: false,
      id: '',
      update_type: null,
      sage_nominal_codes:[],
      sage_departments:[],
      regions:[],
      createForm: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction:'',
        note: '',
        raw_material_items: [],
        required_by:'',
        additional_costs: [],
        delivery_address: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: '',
          note: ''
        }
      },
      countryCodes: [],
      currencyRatios:[],
      customer_addresses: []
    }
  }

  export default {
    name: 'UpdateRmOrderPopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id, update_type) {
        try {
          Object.assign(this.$data, initialState())
          this.id = id
          this.update_type = update_type
          this.open = true;
          await this.getCountryCodes()
          await this.getSageNominalCodes()
          await this.getSageDepartments()
          await this.getRegions()
          await this.getProductOrdersOrder()
          this.storeCurrencyRatio()
        } catch (error) {

        }
      },
      async onClickUpdateProductOrder () {
        const vue = this;
        await this.$vs.loading({
          container: '#rm-order-details-update-popup',
          scale: 0.45
        })
        try {
          this.createForm.additional_costs = this.createForm.additional_costs.map((x) => { 
            return { id: x.id ? x.if : null, name: x.name, amount: Number(x.amount).toFixed(2) }
          })
          await InventoryRepository.updateRmOrderDetails(this.id, this.createForm)
          this.showSuccessMessage('RM order update successfully')
          await vue.$parent.refreshData()
          this.open = false;
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-update-popup > .con-vs-loading')
      },
      async getProductOrdersOrder() {
        await this.$vs.loading({
          container: '#rm-order-details-update-popup',
          scale: 0.45
        })
        const {data} = await InventoryRepository.getRmOrderDetails(this.id)
        this.createForm.line1 =  data.data.line1
        this.createForm.line2 =  data.data.line2
        this.createForm.line3 =  data.data.line3
        this.createForm.town_state =  data.data.town_state
        this.createForm.post_code =  data.data.post_code
        this.createForm.country =  data.data.country
        this.createForm.delivery_instruction =  data.data.delivery_instruction
        this.createForm.note =  data.data.note
        this.createForm.raw_material_items = data.data.raw_material_items
        this.createForm.sage_nominal_code_id = data.data.nominal_code.id
        this.createForm.sage_department_id = data.data.sage_department.id
        this.createForm.region_id = data.data.region.id
        this.createForm.required_by = data.data.required_by
        this.createForm.additional_costs = data.data.additional_cost
        this.createForm.delivery_address = data.data.delivery_address
        this.$vs.loading.close('#rm-order-details-update-popup > .con-vs-loading')
      },

      storeCurrencyRatio(){
        this.currencyRatios = []
        this.createForm.raw_material_items.map(item => {
          const priceVal = parseFloat(item.price) || 0
          const gbpPriceVal = parseFloat(item.gbp_price) || 0
          const ratio = gbpPriceVal !== 0 ? (priceVal / gbpPriceVal) : 0
          this.currencyRatios.push({
            id: item.id,
            ratio: ratio
          })
        })
      },
      onGbpPriceChange(item) {
        if (!item) return
        const ratioObj = this.currencyRatios.find(r => r.id === item.id)
        if (ratioObj && ratioObj.ratio) {
          const val = parseFloat(item.gbp_price)
          if (!isNaN(val)) {
            item.price = (val * ratioObj.ratio).toFixed(2)
          } else {
            item.price = ''
          }
        }
      },
      onSupplierPriceChange(item) {
        if (!item) return
        const ratioObj = this.currencyRatios.find(r => r.id === item.id)
        if (ratioObj && ratioObj.ratio) {
          const val = parseFloat(item.price)
          if (!isNaN(val)) {
            item.gbp_price = ratioObj.ratio !== 0 ? (val / ratioObj.ratio).toFixed(2) : '0.00'
          } else {
            item.gbp_price = ''
          }
        }
      },
      async onClickUpdateCart(id, qty, gbp_price, index) {
        await this.$vs.loading({
          container: `#update_button${index}`,
          scale: 0.45
        })
        try {
          const item = this.createForm.raw_material_items.find(item => item.id === id)
          const calculatedPrice = (item && !this.__isCurrencyGbp(item.currency))
            ? Number(item.price).toFixed(2)
            : Number(gbp_price).toFixed(2)
          await InventoryRepository.updateRmOrderItems(id, {quantity: qty, gbp_price: Number(gbp_price).toFixed(2), price: calculatedPrice})
          await this.$parent.refreshData()
          this.showSuccessMessage('RM item updated successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#update_button${index} > .con-vs-loading`)
      },
      async getCountryCodes() {
        await this.$vs.loading({
          container: '#rm-order-details-update-popup',
          scale: 0.45
        })
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        this.$vs.loading.close('#rm-order-details-update-popup > .con-vs-loading')
      },
      async getSageNominalCodes(){
        this.$vs.loading()
        const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
        this.sage_nominal_codes =  data.data
        this.$vs.loading.close()
      },
      async getSageDepartments(){
        this.$vs.loading()
        const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
        this.sage_departments =  data.data
        this.$vs.loading.close()
      },
      async getRegions(){
        this.$vs.loading()
        const {data} = await RegionsRepository.getListOfRegions()
        this.regions =  data.data
        this.$vs.loading.close()
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      async onClickClose() {
        this.open = false;
      },
      onClickAddNewCost() {
        this.createForm.additional_costs.push({'name' : '', amount: '0.00'})
      },
      onClickRemoveCost(index) {
        this.createForm.additional_costs.splice(index, 1)
      },
      async onSelectCustomerDropdown(data) {
        this.customer_addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(data.id)).data.data;
      },
      onChangeSelectDeliveryAddress(selected) {
        this.createForm.delivery_address.name = selected.name
        this.createForm.delivery_address.line1 = selected.line1
        this.createForm.delivery_address.line2 = selected.line2
        this.createForm.delivery_address.line3 = selected.line3
        this.createForm.delivery_address.town_state = selected.town_state
        this.createForm.delivery_address.post_code = selected.post_code
        this.createForm.delivery_address.country = selected.country
        this.createForm.delivery_address.note = selected.additional_info || selected.notes
      },
    },
    components: {
      'v-select': vSelect,
      flatPickr,
      CustomerDropdown
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .update-rm-order-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }

</style>
